import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export { GetDashboardEntries };

function GetDashboardEntries(requestObject, onSuccess, onError) {
  var headers = getAuthHeader();

  const requestBody = {
    startDate: requestObject?.startDate ?? requestObject?.validFrom ?? null,
    endDate: requestObject?.endDate ?? requestObject?.validTo ?? null,
    language: requestObject?.language ?? "de-CH",
    configurationId: requestObject?.configurationId ?? null,
    pathFilter: requestObject?.pathFilter ?? null,
  };

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + "/publicholidaydashboard",
      requestBody,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}
